// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 4 ? "portaInit" : chunkId) + "." + {"4":"24b4c7064dafd2868c37","5":"197f6b9022333f541db4"}[chunkId] + ".js";
};